module.exports = __webpack_public_path__ + "static/media/card-lib.1c51b802.jpg";